export default {
    'success.created': 'krijuar me sukses!',
    'success.updated': 'përditësuar me sukses!',
    'success.saved': 'U ruajt me sukses!',
    'success.sold': 'Polica u shit me sukses!',
    'success.sold1': 'U shit me sukses me serialin ne iosa:',
    'success.assigned': 'Agjenti u ricaktua me sukses!',
    'success.templates': 'Paketa u përditësua me sukses!',
    'success.gpsAccept': 'Aksioni u krye me sukses!',
    'success.gpsCanceled': 'Aksioni u anulua!',
    'success.continue': 'Gjithmonë mund të vazhdosh manualisht',
    'success.agenciesTemplate': 'Agjencitë u përditësuan me sukses!',
    'success.cancelPolicy': 'Polica u anulua me sukses!',
    'loading.accountDetails': 'Duke përditësuar detajet e llogarisë...',
};
